import React from "react";

export default function MetricCard({ label, value, sub, color, warn }) {
    return (
        <div
            className="rd-metric-card"
            style={{
                "--rd-metric-border": warn ? "rgba(251, 191, 36, 0.4)" : "var(--savvy-border)",
                "--rd-metric-color": color || "var(--savvy-text)",
            }}
        >
            <div className="rd-metric-label">
                {label}
            </div>
            <div className="rd-metric-value">
                {value ?? "—"}
            </div>
            {sub && (
                <div className="rd-metric-sub">{sub}</div>
            )}
        </div>
    );
}
